import type { IProduct } from '../types';
import { formatPhone } from './formatPhone';

export function formatTopupNumber(product: IProduct, number: string) {
  if (product.category === 'mobile-topup' || product.category === 'data-plan') {
    return { title: 'Teléfono', value: formatPhone(number) };
  } else if (product.category === 'betting-topup') {
    return { title: 'Cuenta', value: number };
  } else {
    return { title: 'Contrato', value: number };
  }
}
